import React from "react"

const FriendNo1=()=>{
    return(
        <div>
            Friend no 1
        </div>
    )

}

export default FriendNo1